import { InputPinCode } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React from 'react';
import toast from 'react-hot-toast';
import { useChangePinCodeMutation } from 'services';
import { handleLogout } from 'utils/helpers';

import { structure } from './config';

const ChangePasswordFeature = (): JSX.Element => {
  const { isLoading, mutateAsync } = useChangePinCodeMutation();

  const handleOnChangePassword = async (values: any) => {
    const { oldPinCode, confirmNewPinCode } = values;

    try {
      await mutateAsync({ oldPinCode, newPinCode: confirmNewPinCode });

      toast.success('Cập nhật Mật khẩu thành công, vui lòng đăng nhập lại!');

      handleLogout();
    } catch (error) {}
  };

  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure,
    onSubmit: handleOnChangePassword,
  });

  return (
    <div className='change-password'>
      <div className='row'>
        <div className='col-12 change-password__form__col'>
          <div className='change-password__form'>
            <div className='change-password__form__input'>
              <div className='row'>
                <div className='col-12'>
                  <InputWraper
                    label='Mật khẩu hiện tại'
                    // placeholder={translate('Enter current password')}
                    inputProps={getInputProps('oldPinCode')}
                    component={InputPinCode}
                  />
                </div>
                <div className='col-12'>
                  <InputWraper
                    label='Mật khẩu mới'
                    // placeholder={translate("Enter new password")}
                    inputProps={getInputProps('newPinCode')}
                    component={InputPinCode}
                  />
                </div>
                <div className='col-12'>
                  <InputWraper
                    label='Xác nhận mật khẩu mới'
                    // placeholder={translate('Enter confirm password')}
                    inputProps={getInputProps('confirmNewPinCode')}
                    component={InputPinCode}
                  />
                </div>
              </div>
            </div>
            <div className='change-password__form__action'>
              <Button
                label='Cập nhật'
                type='submit'
                buttonType='success'
                isLoading={isSubmitting || isLoading}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
        {/* <div className="col-md-4 col-xl-8 change-password__banner__col">
          <div className="change-password__banner">
            <img className="change-password__banner__img" src="/assets/images/change-password-cover-image.png" alt="" />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ChangePasswordFeature;
